module.exports = __webpack_public_path__ + "img/inktober_2020_10_hope_with_arrow.f840f843.jpg";